import React, { useState, useEffect, useLayoutEffect } from "react"
import Modal from 'react-modal'; //http://reactcommunity.org/react-modal/

export default function StepsModal({title, slug, steps, maxWidth, backdropClose, confirmClose, startOpened, endpoint, thanks, fail, onSubmit, afterSubmit, beforeSubmit, handleCustomKeys, handleCustomValues, hardcodedData, dataTags, editData})
{            
    const setting =
    {
        id: 'id_' + (slug || 'new-step-modal'),
        title : title || 'Steps Modal',
        maxWidth: maxWidth !== undefined ? maxWidth : '600px',
        backdrop: backdropClose !== undefined ? backdropClose : true,
        startOpened: startOpened !== undefined ? startOpened : false,
        confirmClose: confirmClose !== undefined ? confirmClose : false,   
        thanks: thanks || 'default',
        fail: fail || 'default',
        steps: steps.length
    } 

    const firstStatus = () =>
    {
        const modalsteps = []            
        
        steps.map((step, index) =>
        {            
            const status = index === 0 ? 'step current' : 'step'            
            modalsteps.push(status)
        })        

        return modalsteps
    }
    
    const getTitle = (were) =>
    {
        const title = setting.title          
        if(!steps[were].title) return title        
        return steps[were].title 
    }

    const [modalTitle, setModalTitle] = useState(getTitle(0))  
    const [errorMessage, setErrorMessage] = useState('')
    const [modalConfirmClass, setModalConfirmClass] = useState('modal-steps-confirm')
    const [modalOkClass, setModalOkClass] = useState('modal-steps-ok')
    const [modalFailClass, setModalFailClass] = useState('modal-steps-fail')    
    const [percentageWidth, setPercentageWidth] = useState('0%')
    const [percentageTxt, setPercentageTxt] = useState('0%')
    const [stepCurrent, setStepCurrent] = useState(0)
    const [stepsStatus, setStepsStatus] = useState(firstStatus())
    const [modalIsOpen, setIsOpen] = useState((setting.startOpened ||false))
    const [trigger, setTrigger] = useState(null)
    const [sending, setSending] = useState(false)
    const [modalStyles, setModalStyles] = useState(
    {
        content: 
        {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',            
            borderRadius : '4px',
            border: 'none',
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.12)',            
            width: setting.maxWidth,
        }
    })

    Modal.defaultStyles.overlay.backgroundColor = '#00000085'
    Modal.defaultStyles.overlay.zIndex = '1050';    

    const hideConfirm = (e) =>
    {
        e.preventDefault(e)
        setModalConfirmClass('modal-steps-confirm')
    }

    const getId = () => { return setting.id }      

    const setPercentage = (step) =>
    {
        const total = setting.steps - 1
        const percentage = step/total*100
        setPercentageWidth(`${percentage}%`)
        setPercentageTxt(`${Math.floor(percentage)}%`)
    }

    const resetModal = () =>
    {
        setStepCurrent(0)
        setStepsStatus(firstStatus())
        setModalConfirmClass('modal-steps-confirm')
        setModalOkClass('modal-steps-ok')
        setModalFailClass('modal-steps-fail')
        setPercentageWidth('0%')
        setPercentageTxt('0%')
        setModalStyles(
        {
            content: 
            {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',            
                borderRadius : '4px',
                border: 'none',
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.12)',
                width: setting.maxWidth,
            }
        })
    }

    const openModal = (e)  =>
    {
        setTrigger(e.target)        
        e.preventDefault(e)
        resetModal()
        setIsOpen(true)
    }

    const forceCloseModal = (e) =>
    {        
        e.preventDefault(e)
        setIsOpen(false)
    }

    const closeModal = (e) =>
    {
        e.preventDefault(e)   
        
        if(setting.confirmClose)
        {
            setModalConfirmClass('modal-steps-confirm show')
            return
        }
        
        setIsOpen(false)
    }

    const validate = (validations) =>
    {
        let status = false 
        let msg = ''       

        for (let i = 0; i < validations.length; i++)
        {                       
            const validation = validations[i]
            const getTarget = () =>
            {
                const element = document.getElementsByClassName(`input_${validation.name}`)                
                if(!element) return false                
                if(element.length > 0) return element[0]                
            }

            const target = getTarget()            

            if(target.classList.contains('hide')) return true

            const validate = validation.validate

            if(target === undefined)
            {
                setErrorMessage(`Field ${validation.name} is missing`)
                return false
            } 

            for (const [key, value] of validate) 
            {
                status = false    
                msg = value 
                
                const numbers = /^[0-9]+$/ 
                const parts =  value.split('|') 

                switch(key)
                {
                    case 'required': 
                        if(target.value !== '') status = true                              
                        break

                    case 'numbers':
                        if(target.value.match(numbers)) status = true
                        break

                    case 'length':
                        let length = 1                                               
                        if(parts.length !== 0) length = parts[0].trim(); msg = parts[1].trim()
                        if(length.match(numbers)) if(target.value.length === parseInt(length)) status = true 
                        break

                    case 'minchars':
                        let min = 1                                                                       
                        if(parts.length !== 0) min = parts[0].trim(); msg = parts[1].trim()
                        if(min.match(numbers)) if(target.value.length >= parseInt(min)) status = true 
                        break

                    case 'maxchars':
                        let max = 1                                                                       
                        if(parts.length !== 0) max = parts[0].trim(); msg = parts[1].trim()
                        if(max.match(numbers)) if(target.value.length <= parseInt(max)) status = true
                        break

                    case 'checked':
                        const targets = document.getElementsByName(validation.name)                         
                        for(let i = 0; i < targets.length; i++) 
                        {
                           if(targets[i].checked) status = true 
                        }                        
                        break

                    case 'stars':                        
                        if(parseFloat(target.value) !== 0) status = true 
                        break

                    default:
                        status = true 
                        break
                }                

                if(!status)
                {
                    setErrorMessage(msg)
                    return false
                }
            }            
        }

        return status
    }

    const checkWidth = (were) =>
    {
        let target = ''
        let width = setting.maxWidth
        
        switch(were)
        {
            case 'next':
                target = stepCurrent + 1
                break;

            case 'back':
                target = stepCurrent - 1
                break;
        }

        if(steps[target])
        {             
            if(steps[target].width) width = steps[target].width

            setModalStyles(
            {
                content: 
                {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)',            
                    borderRadius : '4px',
                    border: 'none',
                    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.12)',
                    width: width,
                }
            })
        }
    }

    const goTo = (direction) =>
    {        
        setErrorMessage('')
        
        const current = stepCurrent
        const newStatus = []
        const were = direction === 'next' ? (current+1) : (current-1)
        const title = getTitle(were)

        stepsStatus.map((step, index) =>
        {
            if(index === current || index !== were) 
            {
                newStatus.push('step')
                return
            }

            if(index === were) 
            {
                newStatus.push('step current')
                return
            }
        })
        
        setStepCurrent(were)
        setStepsStatus(newStatus)
        setModalTitle(title)
        setPercentage(were)
    }

    const goNext = (e) =>
    {
        e.preventDefault(e)  
        
        if(steps[stepCurrent].validate !== undefined)
        {
            if(steps[stepCurrent].validate.length > 0) if(!validate(steps[stepCurrent].validate)) return
        }

        checkWidth('next')
        goTo('next')
    }

    const goBack = (e) =>
    {
        e.preventDefault(e)
        checkWidth('back')
        goTo('back')
    } 

    const submitMsg = (status) =>
    {
        switch(status)
        {
            case 'true':
                goTo(0)
                setModalOkClass('modal-steps-ok show')
                break
            
            case 'false': 
                goTo(0)               
                setModalFailClass('modal-steps-fail show') 
                break
        }
    }
    
    const submitData = (data) =>
    {                
        if(onSubmit)
        {  
            submitMsg(onSubmit(data))
            return        
        }

        if(endpoint)
        {            
            setSending(true)
            
            fetch(endpoint,
            {
                method: 'post',
                headers: {
                    'Content-type': 'application/json',
                },
                body: JSON.stringify(data)                     
            })
            .then((response) => 
            {                
                setSending(false)
                
                if(response.statusText === 'OK') 
                {
                    submitMsg('true') 
                    return
                }

                submitMsg('false')               
            })
            .catch((error) => 
            {              
                submitMsg('false')
                console.log(error)
            })            

            return
        }

        submitMsg('false')
    }

    const handleSubmit = (e) =>
    {        
        e.preventDefault(e)

        if(steps[stepCurrent].validate.length > 0) if(!validate(steps[stepCurrent].validate)) return
        
        const formData = () =>
        {
            const dataType = (value) =>
            {
                if(value.match(/^[0-9]+$/)) value = parseInt(value)
                if(value === 'false') value = false
                if(value === 'true') value = true
                
                return value
            }

            const customValue = (key, value) =>
            {
                switch(key)
                {
                    case 'mobile_phone':
                        value = value.replace(/\D/g,'')
                        break;                    
                } 

                return value
            }

            const addHardcodedData = (formdata, hardcoded) =>
            {
                let object = formdata  
                               
                Object.keys(hardcoded).forEach(k => 
                { 
                    const key = k
                    const value = hardcoded[key]
                    
                    if (!Reflect.has(object, key))
                    {
                        object[key] = value
                        return
                    }

                    if (!Array.isArray(object[key])) 
                    {
                        object[key] = [object[key]]
                    }                    
                    
                    object[key].push(value)   
                })

                return object
            }

            const addDataTags = (formdata, tagID) =>
            {                                               
                const target = typeof tagID === "string" ? document.getElementById(tagID) : trigger                                                  
                if(!target) return
                const tags = target.dataset
                if(!tags) return
                return addHardcodedData(formdata, tags)
            }
            
            const formDataToObject = (formData) =>
            {
                let object = {}

                formData.forEach((value, key) => 
                {                                  
                    value = customValue(key, value)                  
                                        
                    if(handleCustomKeys) key = handleCustomKeys(key) 
                    if(handleCustomValues) value = handleCustomValues(key, value) 

                    //value = dataType(value)                  
                    
                    if (!Reflect.has(object, key))
                    {
                        object[key] = value
                        return
                    }

                    if (!Array.isArray(object[key])) 
                    {
                        object[key] = [object[key]]
                    }                    
                    
                    object[key].push(value)
                })

                return object
            }
            
            let form = document.getElementById(getId()+'-form')
            
            let formdata = new FormData(form)            
            
            let data = formDataToObject(formdata)           

            if(hardcodedData) data = addHardcodedData(data, hardcodedData)
            if(dataTags) data = addDataTags(data, dataTags)
            if(editData) data = editData(data)

            return data
        }
        
        if(beforeSubmit) beforeSubmit(formData())
        submitData(formData())        
        if(afterSubmit) afterSubmit(formData())  
    }     
    
    const getThanks = () =>
    {
        if(setting.thanks === 'default') return '<h3>Thank you! <br/> We received your request.</h3>'
        return(setting.thanks)
    }

    const getFail= () =>
    {
        if(setting.fail === 'default') return '<h3>There was a problem. <br/> Please try again later.</h3>'
        return(setting.fail)
    }

    const Title = () =>
    {
        return(
            <div className="modal-steps-header">
                <h2 dangerouslySetInnerHTML={{__html:modalTitle}}></h2>
                <button className="modal-x-close" onClick={closeModal}></button>
            </div>
        )
    }

    const Percentage = () =>
    {   
        return(
            <div className="modal-steps-percentage">
                {steps.length > 3 &&
                <div className="percentage-container">
                    <div style={{width: percentageWidth}} className="percentage-bar"></div>
                </div>}
                {steps.length <=3 && <div className="line"></div>}
            </div>
        )
    }

    useLayoutEffect(() => 
    {              
        const modalbtn = document.getElementsByClassName(slug+'-btn')        

        for (let i = 0; i < modalbtn.length; i++) 
        {
            modalbtn[i].onclick = openModal
        }
    
    }, [])

    return(
        <Modal
            id={getId()}
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={modalStyles}
            contentLabel="Example Modal"
            shouldCloseOnOverlayClick={setting.backdrop}
            closeTimeoutMS={500}
            preventScroll={true}
            >
            <div>
                <Title />
                <Percentage /> 
            </div>
            <div className="modal-steps-form-container">      
                <form className="modal-steps-form" id={getId()+'-form'} onSubmit={handleSubmit}>
                {                              
                    steps.map((step, index)=> 
                    {                                      
                        const next = step.next || false
                        const back = step.back || false
                        const submit = step.submit || false
                        
                        return(
                            <div className={stepsStatus[index]}>
                                {step.html()}
                                {(back || next || submit) && <div className="actions">
                                    {!sending && back && <button onClick={goBack} className="steps-modal-back">{back}</button>}
                                    {!sending && next && <button onClick={goNext} className="steps-modal-next">{next}</button>}
                                    {submit && 
                                        <>
                                        {!sending && <input type="submit" value={submit}/>}
                                        {sending && <div className="preloader-container"><div className="preloader"></div></div>}
                                        <div className="terms">
                                            <p>By submitting you agree to our <br/><a href="/terms-and-conditions.html" target="_blank">Terms and Conditions</a>.</p>
                                            <p>Your privacy is important to us.<br/> View our <a href="/hometown-privacy-policy" target="_blank">Privacy Policy</a>.</p>
                                        </div>
                                        </>
                                    }
                                </div>}                         
                            </div> 
                        )
                    })
                } 
                {
                    setting.confirmClose && <div className={modalConfirmClass}>                   
                        <h4><b>Don't stop now.</b><br/>
                        You're <span>{percentageTxt}</span> done with your request.</h4>
                        <div className="actions">
                            <button className="steps-modal-back" onClick={forceCloseModal}>close</button>
                            <button onClick={hideConfirm}>continue</button>                               
                        </div>        
                    </div>
                }  
                {
                    <div className={modalOkClass}>
                        <div dangerouslySetInnerHTML={{__html: getThanks()}} />
                        <div className="actions">
                            <button onClick={forceCloseModal}>close</button>      
                        </div>        
                    </div>
                }
                {
                    <div className={modalFailClass}>
                        <div dangerouslySetInnerHTML={{__html: getFail()}} />
                        <div className="actions">
                            <button onClick={forceCloseModal}>close</button>      
                        </div>        
                    </div>
                }         
                {errorMessage !== '' && <div className="error">{errorMessage}</div>}
                </form>
            </div>      
        </Modal>
    )
}